import { createApp } from 'vue'
import TeamListCard from './TeamListCard'

const el = '.kb-component--team-list-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((TeamListCardDOM) => {
            const props = {
                captains: TeamListCardDOM.dataset.captains
                    ? JSON.parse(TeamListCardDOM.dataset.captains)
                    : [],
                imageUrl: TeamListCardDOM.dataset.imageUrl,
                imageAlt: TeamListCardDOM.dataset.imageAlt,
                url: TeamListCardDOM.dataset.url,
                name: TeamListCardDOM.dataset.name,
                membersCount: TeamListCardDOM.dataset.membersCount,
                donationGoals: TeamListCardDOM.dataset.donationGoals,
                donationTotal: TeamListCardDOM.dataset.donationTotal
            }
            const component = createApp(TeamListCard, props).use(Store)
            component.mount(TeamListCardDOM)
        })
    }
}
